import { apiFetch } from "./client";

export interface AgentTask {
  id: string;
  agentId: string;
  companyId: string;
  goalId: string | null;
  announceChannelId: string | null;
  announceChannelName?: string | null;
  announceChannelSlug?: string | null;
  type: "recurring" | "one_off";
  title: string;
  description: string | null;
  cronExpression: string | null;
  timezone: string;
  enabled: boolean;
  status: string;
  lastRunAt: string | null;
  lastResult: { success?: boolean; summary?: string; error?: string; durationMs?: number } | null;
  nextRunAt: string | null;
  nextRun: string | null;
  taskPrompt: string | null;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
  agentName?: string | null;
  isActive?: boolean;
}

export interface AgentTaskRun {
  id: string;
  taskId: string;
  agentId: string;
  status: string;
  result: { summary?: string; error?: string } | null;
  startedAt: string;
  completedAt: string | null;
  durationMs: number | null;
}

export const agentTasksApi = {
  list: (companyId: string, params?: { agentId?: string; type?: string }) => {
    const qs = new URLSearchParams({ companyId });
    if (params?.agentId) qs.set("agentId", params.agentId);
    if (params?.type) qs.set("type", params.type);
    return apiFetch<AgentTask[]>(`/agent-tasks?${qs}`);
  },

  get: (id: string) =>
    apiFetch<AgentTask & { runs: AgentTaskRun[] }>(`/agent-tasks/${id}`),

  create: (data: {
    agentId: string;
    companyId: string;
    type: "recurring" | "one_off";
    title: string;
    description?: string;
    cronExpression?: string;
    timezone?: string;
    taskPrompt?: string;
    goalId?: string | null;
    announceChannelId?: string | null;
  }) =>
    apiFetch<AgentTask>("/agent-tasks", {
      method: "POST",
      body: JSON.stringify(data),
    }),

  update: (id: string, data: Record<string, unknown>) =>
    apiFetch<AgentTask>(`/agent-tasks/${id}`, {
      method: "PATCH",
      body: JSON.stringify(data),
    }),

  delete: (id: string) =>
    apiFetch<void>(`/agent-tasks/${id}`, { method: "DELETE" }),

  trigger: (id: string) =>
    apiFetch<{ success: boolean; summary?: string; error?: string }>(`/agent-tasks/${id}/trigger`, {
      method: "POST",
    }),

  runs: (taskId: string) =>
    apiFetch<AgentTaskRun[]>(`/agent-tasks/${taskId}/runs`),

  syncFromAgent: (agentId: string) =>
    apiFetch<{ created: number; updated: number; completed: number; error?: string }>(
      `/agent-tasks/${agentId}/sync-from-agent`,
      { method: "POST" },
    ),
};
